export const formatCurrency = (amount: number | string, currency: string = 'GBP'): string => {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  if (isNaN(numAmount)) {
    return '0.00';
  }

  // Currency symbol mapping
  const currencySymbols: { [key: string]: string } = {
    'USD': '$',
    'GBP': '£',
    'EUR': '€',
    'JPY': '¥',
    'INR': '₹',
    'CAD': 'C$',
    'AUD': 'A$',
    'CHF': 'CHF'
  };

  const symbol = currencySymbols[currency.toUpperCase()] || '£';
  
  // Format the number with appropriate decimal places
  const formattedAmount = numAmount.toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return `${symbol}${formattedAmount}`;
};

export const getCurrencySymbol = (currency: string = 'GBP'): string => {
  const currencySymbols: { [key: string]: string } = {
    'USD': '$',
    'GBP': '£',
    'EUR': '€',
    'JPY': '¥',
    'INR': '₹',
    'CAD': 'C$',
    'AUD': 'A$',
    'CHF': 'CHF'
  };

  return currencySymbols[currency.toUpperCase()] || '£';
}; 

export const getCurrencyFontClass = (currency: string = 'GBP'): string => {
  if (currency.toUpperCase() === 'INR') {
    return 'font-currency-inr';
  }
  return '';
};